$(document).ready(function() {
  if($('#tab1 table th').length == 5){
     $('.size-tabs table').addClass('five-columns');
  }
});

$("document").ready(function(){
  $(".tab-slider--container .tab-slider--body").hide();
  $(".tab-slider--container").each(function() {
    $(".tab-slider--container .tab-slider--body:first-of-type").show();
  });
});

$(".tab-slider--nav li").click(function() {
  $(".tab-slider--body").hide();
  var activeTab = $(this).attr("rel");
  $('[id="' + activeTab + '"]').fadeIn();
	if($(this).attr("rel") == "tab2"){
		$('.tab-slider--tabs').addClass('slide');
	}else{
		$('.tab-slider--tabs').removeClass('slide');
	}
  $(".tab-slider--nav li").removeClass("active");
  $('[rel="' + activeTab + '"]').addClass("active");
});


$(document).on('click', '.giftwrap-add-to-cart', function(e) {
  e.preventDefault();

  let variant_id = Number($(this).data('variant'));
  var data = {
    "id": variant_id,
    "quantity": 1
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,  //this code is for prestige theme, is to refresh the cart
        detail: {
          quantity: 1
        }
      }));
    }   
  }); 
})
